import { environment } from 'src/environments/environment';
import createApiClient from './AxiosFactory';

const clientBaseUrl = environment.REACT_APP_CLIENT_BASE_URL ?? '';
const endUserBaseUrl = environment.REACT_APP_ENDUSER_BASE_URL ?? '';
const vendorBaseUrl = environment.REACT_APP_VENDOR_BASE_URL ?? '';
const planBaseUrl = environment.REACT_APP_PLAN_BASE_URL ?? '';


export const apiClientService = createApiClient(clientBaseUrl);
export const apiClientEndUserService = createApiClient(endUserBaseUrl);
export const apiClientVendorService = createApiClient(vendorBaseUrl);
export const apiClientPlanService = createApiClient(planBaseUrl);
